namespace RioERP.Orders {
    export interface SerialKeyResponse extends Serenity.SaveResponse {
        SerialKey?: string;
    }
}
